/**
 * PdfViewerControl
 * Renders a PDF using the native browser PDF viewer via an object/embed tag.
 * Performance: Memoized to prevent unnecessary re-renders
 */

import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';

export const PdfViewerControl = memo((props: ControlRendererProps) => {
  const { control } = props;
  const src = (control as any).src as string | undefined;
  const height = (control as any).height ?? 600;

  if (!src) {
    return <div className="af-pdf-viewer-control--empty">No PDF source</div>;
  }

  return (
    <div className="af-pdf-viewer-control" data-control-id={control.id}>
      {control.label && <p className="af-pdf-viewer-control__label">{control.label}</p>}
      <object
        data={src}
        type="application/pdf"
        width="100%"
        height={height}
        aria-label={control.label ?? 'PDF document'}
      >
        <a href={src} target="_blank" rel="noopener noreferrer">
          Open PDF
        </a>
      </object>
    </div>
  );
});

PdfViewerControl.displayName = 'PdfViewerControl';

export default PdfViewerControl;
